module.exports = __webpack_public_path__ + "assets/img/pl1.79574ca6.png";